import ColumnSet from '@/components/grid/columns/column-set';
import ColumnsDefinition from '@/common/definitions/columns/invoices';

export default new ColumnSet({
    id: 'invoice-list',
    ...ColumnsDefinition,
});
